import {useMediaQuery} from '@mui/material'

/** 프로젝트 공통 모바일 기준점. 변경 시 이 상수만 수정한다. */
export const MOBILE_BREAKPOINT = '(max-width: 991px)'

/**
 * 모바일 여부 판정. 디바이스(UA)가 아닌 뷰포트 폭 기준이라
 * PC 브라우저 창을 줄여도 동일하게 동작한다.
 */
const useIsMobile = () => useMediaQuery(MOBILE_BREAKPOINT)

export default useIsMobile
